import { Children, cloneElement, FC } from "react";
import clsx from "clsx";

interface Props {
  isLoading: boolean;
  classLoader?: string;
  classNameLoader?: string;
  children?: any;
}

export const Loader: FC<Props> = ({
  isLoading,
  classLoader,
  classNameLoader,
  children,
}) =>
  children ? (
    Children.map(children, (child) =>
      cloneElement(child, {
        className: clsx(child.props.className, { relative: isLoading }),
        children: (
          <>
            {child.props.children}
            {isLoading && (
              <div className={clsx("loader", classNameLoader)}>
                <span className="spinner" />
              </div>
            )}
          </>
        ),
      })
    )
  ) : isLoading ? (
    <div className={clsx("empty-loader relative", classLoader)}>
      <div className={clsx("loader", classNameLoader)}>
        <span className="spinner" />
      </div>
    </div>
  ) : (
    <></>
  );
